<template>
  <div>
    <el-col>
      <el-form :inline="true" class="demo-inline-form" :model="searchForm">
        <el-form-item label="门店编号">
          <el-input
            class="selectWidth"
            placeholder="请输入门店编号"
            v-model="searchForm.FMerchantId"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="门店名称">
          <el-input
            class="selectWidth"
            placeholder="请输入门店名称"
            v-model="searchForm.FMerchantId"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="上级机构名称">
          <el-input
            class="selectWidth"
            placeholder="请输入上级机构名称"
            v-model="searchForm.FMerchantId"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="上级机构编号">
          <el-input
            class="selectWidth"
            placeholder="请输入上级机构编号"
            v-model="searchForm.FMerchantId"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            class="selectWidth"
            v-model="searchForm.statusCode"
            placeholder="请选择"
            clearable>
            <el-option label="资料待完善" value="4"></el-option>
            <el-option label="待审核" value="0"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核不通过" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易状态">
          <el-select
            class="selectWidth"
            v-model="searchForm.FDealState"
            placeholder="请选择"
            clearable>
            <el-option label="开通" value="0"></el-option>
            <el-option label="冻结" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算状态">
          <el-select
            class="selectWidth"
            v-model="searchForm.FSettleState"
            placeholder="请选择"
            clearable>
            <el-option label="D1开通、D0关闭" value="0"></el-option>
            <el-option label="D0/D1开通" value="1"></el-option>
            <el-option label="关闭" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <auth-button
            opt="search"
            icon="el-icon-search"
            label="查询"
            @click.native="onSubmit"
            :loading="searchLoading">
          </auth-button>
          <auth-button
            opt="search"
            :plain="true"
            label="重置"
            @click.native="onReset"
            :loading="resetLoading">
          </auth-button>
        </el-form-item>
      </el-form>
    </el-col>

  </div>
</template>

<script>
export default {
  props: {
    searchLoading: {
      type: Boolean,
      default: false
    },
    resetLoading: {
      type: Boolean,
      default: false
    },
    formInfo: {
      type: Object,
      default: () => {
        return {
        }
      }
    }
  },
  data () {
    return {
    // 记录初始值
      initForm: Object.assign({}, this.formInfo),
      searchForm: Object.assign({}, this.formInfo)
    }
  },
  watch: {
    formInfo: {
      handler (val) {
        this.searchForm = Object.assign({}, val)
      },
      deep: true
    }
  },
  methods: {
    onSubmit () {
      this.$emit('search', this.searchForm, 'searchLoading')
    },
    onReset () {
      // 重置时
      this.searchForm = this.initForm
      this.$emit('search', this.searchForm, 'resetLoading')
    }
  }
}
</script>

<style lang="scss" scoped>
.selectWidth{
    width: 220px;
  }
</style>
